import { webhookUrl } from "../api"
import axios from 'axios'
import { notification } from 'antd'
export const webhookAction = async params => {
    try {
      let response = await axios.get(webhookUrl())
      if (response.data.job.id) {
        notification.success({
          message: 'Build scheduled successfully,check in 5 to 10 minutes!'
        })
        return
      }
     else{
        notification.error({
            message: 'Failed to trigger the build.'
          })
          return 
     }
    } catch (err) {
      notification.error({
        message: 'Error'
      })
      return null
    }
  }